import React from "react";
import { Helmet } from "react-helmet";
import ListingLayout from "../../Components/UI/ListingLayout";
import { CcThemeProvider, CcTheme } from "../../design-system/carecentre";
import { displayNamesForItems } from "../../Data/subscriptionBundles";
import SubscribePrompt from "./SubscribePrompt";

const Landing = ({ item }) => {
  const items = item ? [item] : [];
  const moduleName = displayNamesForItems(items).join(" or ");

  return (
    <ListingLayout
      hideAdd
      hasFilter={false}
      showLocationToggle
      zenBackdrop
      hasLargeContent
    >
      <Helmet>
        <title>{moduleName} — Subscribe</title>
      </Helmet>
      <CcThemeProvider>
        <CcTheme>
          <SubscribePrompt items={items} />
        </CcTheme>
      </CcThemeProvider>
    </ListingLayout>
  );
};

export default Landing;
